import { ColorControl } from '@/components/Modals/BackgroundGallery/ColorControl';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { StoreType } from 'polotno/model/store';
import { useRef, useState } from 'react';
import { SectionContainer } from '../common/SectionContainer';
import { SectionTitle, StyledText } from '../common/SectionTitle';
import { DefaultBackgroundsPanel } from './DefaultBackgroundsPanel';
import { MyBackgrounds } from './MyBackgrounds';

const BackgroundPanelContainer = styled.div`
    padding: 20px 20px !important;
    gap: 24px;
    display: flex;
    flex-direction: column;
`;

const DefaultBackgrounds = styled.div<{ maxHeight: string }>`
    max-height: ${({ maxHeight }) => maxHeight};
`;

const SectionContainerWithoutGap = styled(SectionContainer)`
    gap: 0px !important;
`;

const StyledSectionTitle = styled(SectionTitle)`
    padding-bottom: 16px;
    background-color: white;
    position: sticky;
    top: 0;
    z-index: 1;
`;

export const isSelected = (background: string, store: StoreType) => {
    return background === store.activePage?.background;
};

export const BackgroundPanel = observer(() => {
    const { store } = useAdvancedEditorContext();
    const [expandedUpload, setExpandedUpload] = useState(true);
    const [expandedGallery, setExpandedGallery] = useState(true);

    const colorSection = useRef<HTMLDivElement>(null);
    const uploadSection = useRef<HTMLDivElement>(null);

    const colorSectionHeight = colorSection?.current?.getBoundingClientRect().height || 0;
    const uploadSectionHeight = uploadSection?.current?.getBoundingClientRect().height || 0;

    const hadleColorChange = (color: string) => {
        store.activePage.set({ background: color });
    };

    return (
        <BackgroundPanelContainer data-testid="background-panel">
            {/*Color section*/}
            <SectionContainer ref={colorSection}>
                <StyledText>Color</StyledText>
                <ColorControl value={store.activePage?.background} onChange={hadleColorChange} />
            </SectionContainer>

            {/*Upload section*/}
            <SectionContainer ref={uploadSection}>
                <SectionTitle text={'My backgrounds'} show={expandedUpload} setShow={setExpandedUpload} />
                {expandedUpload && <MyBackgrounds />}
            </SectionContainer>

            {/*Gallery section*/}
            {/*color section + upload section + gap + padding*/}
            <SectionContainerWithoutGap height={`calc(100% - ${colorSectionHeight + uploadSectionHeight + 32 + 20}px)`}>
                <StyledSectionTitle text={'Background gallery'} show={expandedGallery} setShow={setExpandedGallery} />
                {expandedGallery && (
                    <DefaultBackgrounds
                        // title + margin
                        maxHeight={`calc(100% - ${19 + 16}px)`}>
                        <DefaultBackgroundsPanel store={store} />
                    </DefaultBackgrounds>
                )}
            </SectionContainerWithoutGap>
        </BackgroundPanelContainer>
    );
});
